module.exports = __webpack_public_path__ + "static/media/tivity.18afb8bc.svg";